module.exports = __webpack_public_path__ + "static/media/87gal15.fde09f84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/87gal/87gal15.jpg
// module id = 205
// module chunks = 0